import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0990. 支払タスク削除
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:id/
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};

const destroyPaymentTask = (props: Props): Promise<PaymentTask> => {
  return axios.delete(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.id}`);
};

export const useDestroyPaymentTask = () => {
  return useMutation({
    mutationFn: destroyPaymentTask,
  });
};
